<template>
  <div class="modal__backdrop">
    <div class="modal">
      <header class="modal__header">
        <h2>{{ restrictionsInformationTitle }}</h2>
      </header>
      <section class="modal__body">
        <p name="body" v-if="!toDisplayRightsRestrictions || toDisplayRightsRestrictions.length === 0">
          Keine bekannten Rechterückrufe für den gewählten Labelcode!
        </p>
        <table v-if="toDisplayRightsRestrictions && toDisplayRightsRestrictions.length > 0" aria-describedby="Übersicht Rechterückrufe">
          <thead class="modal__body__header">
            <th scope="col">Rechterückruf-Kürzel</th>
            <th scope="col">Beschreibung</th>
          </thead>
          <tbody>
            <tr class="modal__body__item" v-for="toDisplayRightsRestriction in toDisplayRightsRestrictions" v-bind:key="toDisplayRightsRestriction.code">
              <td class="modal__body__item--name"><strong>{{ toDisplayRightsRestriction.code }}</strong></td>
              <td class="modal__body__item--description">{{ toDisplayRightsRestriction.description }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <footer class="modal__footer">
        <button
          type="button"
          class="modal__footer__btn"
          @click="close"
        >
          schließen
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResultModal',
  props: {
    toDisplayRightsRestrictions: Array,
    restrictionsInformationTitle: String
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .modal__backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 90%;
    max-height: 65%;

    .modal__header {
      display: flex;
      border-bottom: 1px solid #eeeeee;
      justify-content: flex-start;
      background-color: #ffffff;
      color: #000000;
      position: relative;
      top: auto;
      width: auto;
      font-weight: normal;
      padding: 15px;
    }

    .modal__body {
      position: relative;
      overflow-y: scroll;
      padding: 20px 10px;

      .modal__body__header {
        display: none;
      }

      .modal__body__item {
        background: #ffffff;

        td {
          border-bottom: 1px solid black;
          border-right: none;
          height: 3em;
          padding: 1% 1%;
          vertical-align: top;

          &:first-child {
            width: 5%;
          }

          &:last-child {
            border-right: none;
          }
        }

        &:nth-child(even) {
          background-color: #e8e8e8;
        }
        &:nth-child(odd) {
          background-color: #ffffff;
        }
        &:last-child {
          td {
            border-bottom: none;
          }
        }
      }
    }

    .modal__footer {
      display: flex;
      border-top: 1px solid #eeeeee;
      justify-content: flex-end;
      background-color: #ffffff;
      color: #000000;
      position: relative;
      bottom: auto;
      width: auto;
      font-weight: normal;
      padding: 15px;

      .modal__footer__btn {
        color: white;
        font-weight: bold;
        background: #aa3c14;
        border: 1px solid #aa3c14;
        border-radius: 2px;
      }
    }
  }
</style>
